module.exports = __webpack_public_path__ + "static/media/protein-scoop.a291ec9b.jpg";